/** Parametri adrese stranice Firme za dostavu. */
export const FIRMS_QUERY = {
  status: "s",
  legacy: "ui",
};

/** ?ui=stari vraća staru stranicu (isti naziv kao u finansijama i korisnicima dostave) */
export const LEGACY_UI_VALUE = "stari";

export const STATUS_VALUES = ["active", "inactive", "billing"];
